import { DropdownOption } from "../../types/dropdown";
import { getStatusIcon, getStatusColor } from "../utils/statusUtils";
import { formatStatusLabel } from "../../utils";

interface TenantRequestStatsProps {
  requestStatusOptions: DropdownOption[];
  stats: Record<string, number>;
}

const TenantRequestStats = ({ requestStatusOptions, stats }: TenantRequestStatsProps) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-6 mb-6 overflow-x-auto">
      <div className="flex items-center justify-between">
        <div
          className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 w-full items-stretch"
        >
          {requestStatusOptions.map((statusOpt) => {
            const Icon = getStatusIcon(statusOpt.label);
            const colors = getStatusColor(statusOpt.label);
            return (
              <div
                key={statusOpt.value}
                className="flex flex-col items-start gap-2 p-3 rounded-lg min-h-[72px]"
              >
                <div className="flex items-center gap-3 w-full">
                  <div
                    className={`${colors.bg} rounded-lg flex items-center justify-center w-10 h-10 shrink-0`}
                  >
                    <Icon className={`w-5 h-5 ${colors.text}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-gray-500 dark:text-gray-400 leading-tight truncate">
                      {formatStatusLabel(statusOpt.label)}
                    </p>
                  </div>
                </div>

                <div className="mt-0">
                  <p className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white">
                    {stats[statusOpt.label] || 0}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="hidden lg:flex lg:items-center lg:gap-2">
          <img src="/images/icon (4).png" alt="Tenant Request" className="w-24 h-24" />
        </div>
      </div>
    </div>
  );
};

export default TenantRequestStats;